export default __webpack_public_path__ + "static/Vision_film_short-505dbd2015ea48fc13ac4f40f4fb75ea.mp4";